var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showClock)?_c('p',{staticClass:"time m0",class:{ 'time--is-running': _vm.isRunning }},[_vm._v(_vm._s(_vm.timeRunning))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }